export default {
  "ja": {
    "translation": {
      "home": {
        "label_redmine_list": "Redmineリスト",
        "label_project_list": "プロジェクトリスト",
        "text_add_redmine": "Redmine APIの登録・選択をしてください。",
        "button_add_redmine": "Redmineを追加する",
        "label_redmine_config": "Redmine設定",
        "field_redmine_name": "Redmine 表示名",
        "field_redmine_url": "Redmine URL",
        "field_redmine_key": "Redmine APIキー",
        "error_invalid_url_or_key": "Redmine URL または API Key が正しくありません。",
        "label_due_date_issues": "期日が{{term}}日以内のチケット",
        'edit_redmine_form': {
          'label_edit_redmine': 'Redmine登録情報の編集',
          'label_edit_detail': '詳細を編集する',
        },
        "delete_user_account": {
          "label_delete_user": "アカウント削除",
          "button_delete": "RedMica Bridgeのアカウント削除を依頼する",
          "agree": "注意事項を確認し同意する。",
          "confirm": "削除依頼の最終確認",
          "error_message": "処理の受け付けが出来ませんでした。時間をおいてからもう一度お試しください。",
        }
      },

      "issu_filter": {
        "label_filter": "チケットフィルタ"
      },
    
      "issue_detail": {
        "field_notes": "コメント",
        "label_add_note": "コメントを追加",
        "button_open_redmine": "Redmineで開く",
        "button_back_to_list": "一覧に戻る"
      },

      "issue_form": {
        "text_set_project": "チケットを追加する場合はプロジェクトを選択してください"
      },
    
      "text_not_set_redmine": "Redmineが選択されていません",
    
      "label_logout": "ログアウト",
      "label_home": "ホーム",
      "label_projects": "プロジェクト一覧",
      "label_project": "プロジェクト",
      "label_issues": "チケット一覧",
      "label_issue": "チケット",
      "label_issue_new": "新しいチケット",
      "label_issue_update": "チケットの編集",
      "label_all": "すべて",
      "label_open_issues": "未完了",
      "label_bookmarks": "ブックマーク",
      "label_tasks": "タスク一覧（α）",
      "label_search": "検索",
    
      "button_save": "保存",
      "button_edit": "編集",
      "button_clear": "クリア",
      "button_cancel": "キャンセル",
      "button_delete": "削除",
    
      "field_subject": "題名",
      "field_description": "説明",
      "field_due_date": "期日",
      "field_start_date": "開始日",
      "field_status": "ステータス",
      "field_author": "作成者",
      "field_assigned_to": "担当者",
      "field_tracker": "トラッカー",

      "tasks": {
        "create": "タスク登録",
      },
      "task_status": {
        "all": "すべて",
        "in_progress": "未完了のみ",
        "closed": "完了のみ",
      },
    }
  }
}
